export const GET_WEB_SETTINGS = 'GET_WEB_SETTINGS';
